import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/buildingUnit';
import { fetchTreeList } from '@/api/PMS/treeList/index.js';
import { fetchListByType } from '@/api/PMS/dic/dic';
export default {
  props: ['routerIdArr', 'keyValue', 'showDialog', 'isDetail'],
  data: function data() {
    var checkOrder = function checkOrder(rule, value, callback) {
      setTimeout(function () {
        if (!Number.isInteger(Number(value))) {
          callback(new Error('请输入数字值'));
        } else {
          callback();
        }
      }, 100);
    };

    return {
      ruleForm: {
        upIdList: '',
        unintName: '',
        unintOrder: ''
      },
      rules: {
        upIdList: [{
          required: true,
          message: '请选择上级机构',
          trigger: 'blur'
        }],
        unintName: [{
          required: true,
          message: '请输入名称',
          trigger: 'blur'
        }],
        unintOrder: [{
          required: true,
          message: '请输入序号',
          trigger: 'blur'
        }, {
          validator: checkOrder,
          trigger: 'blur'
        }]
      },
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      typeOption: [],
      useOption: [],
      towardOption: [],
      childData: {
        upIdList: [],
        unintOrder: 0
      },
      options: [],
      cascaderItem: []
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.typeOption = [];
      this.useOption = [];
      this.towardOption = [];
      this.loadMenuTree();
      this.loadTypeOptions();
      this.loadUseOptions();
      this.loadTowardOptions();
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          _this.childData.upIdList = _this.childData.upIdList.join(',').split(',');
        });
      } else {
        this.childData = {};
        this.childData.upIdList = this.routerIdArr;
        setTimeout(function () {
          _this.getCascaderItem(_this.childData.upIdList, _this.options);
        }, 1000);
      }
    },
    loadMenuTree: function loadMenuTree() {
      var _this2 = this;

      var treeQuery = {
        flag: 2
      };
      fetchTreeList(treeQuery).then(function (response) {
        _this2.options = response.data.data;
      });
    },
    loadTypeOptions: function loadTypeOptions() {
      var _this3 = this;

      fetchListByType('building_type').then(function (r) {
        _this3.typeOption = r.data.data;
      });
    },
    loadUseOptions: function loadUseOptions() {
      var _this4 = this;

      fetchListByType('building_use').then(function (r) {
        _this4.useOption = r.data.data;
      });
    },
    loadTowardOptions: function loadTowardOptions() {
      var _this5 = this;

      fetchListByType('building_toward').then(function (r) {
        _this5.towardOption = r.data.data;
      });
    },
    changeTypeValue: function changeTypeValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.buildingType === val;
      });
      this.childData.buildingType = obj.dicName;
    },
    changeUseValue: function changeUseValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.buildingUse = obj.dicName;
    },
    changeTowardValue: function changeTowardValue(val) {
      var obj = {};
      obj = this.locations.find(function (item) {
        return item.dicValue === val;
      });
      this.childData.menuVueTarget = obj.dicName;
    },
    // 获取级联选择器的下拉选项的数据
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this6 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this6.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    getNode: function getNode() {
      this.cascaderItem = [];
      this.getCascaderItem(this.childData.upIdList, this.options);
    },
    handCreate: function handCreate() {
      var _this7 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this7.childData.buildingId = _this7.childData.upIdList[_this7.childData.upIdList.length - 1];

          if (_this7.keyValue > 0) {
            delete _this7.childData.upIdList;
            delete _this7.childData.buildingName;
            delete _this7.childData.areaGroupName;
            delete _this7.childData.areaName;
            delete _this7.childData.unintTowardName;
            delete _this7.childData.unintTypeName;
            delete _this7.childData.unintUseName;
            delete _this7.childData.upAreaId;
            delete _this7.childData.areaId;
            delete _this7.childData.opDate;
            delete _this7.childData.op;

            if (_this7.childData.unintOrder == null || _this7.childData.unintOrder == '') {
              _this7.childData.unintOrder = 0;
            }

            fetchUpdate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'update'
              });
            });
          } else {
            if (_this7.cascaderItem[_this7.cascaderItem.length - 1].flag !== '2') {
              _this7.$message({
                message: '上级机构请选择正确的楼栋',
                type: 'error',
                duration: 3000
              });

              return false;
            }

            delete _this7.childData.upIdList;

            if (_this7.childData.unintOrder == null || _this7.childData.unintOrder == '') {
              _this7.childData.unintOrder = 0;
            }

            fetchCreate(_this7.childData).then(function () {
              _this7.$emit('handCancle', true);

              _this7.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this7.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'unitAdd');
    }
  }
};